import { Component, OnInit, ViewChildren, QueryList } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { timer, Subscription } from "rxjs";
import { map, take } from "rxjs/operators";

import 'rxjs/add/observable/timer'
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/take'


import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/takeWhile';
import 'rxjs/add/observable/timer'
import { FormGroup, FormBuilder, Validators } from '@angular/forms';

import Swal from 'sweetalert2'
import { DatePipe } from '@angular/common';
import { Console } from 'console';
import { LiveBiddingViewService } from 'src/app/Shared/Services/live-bidding-view.service';

declare var $: any;

@Component({
  selector: 'app-live-bidding-view',
  templateUrl: './live-bidding-view.component.html',
  styleUrls: ['./live-bidding-view.component.css']
})
export class LiveBiddingViewComponent implements OnInit {

  AuctionBiddingPlaceListBind: any = [];
  ShowStartBiddingListData: any = [];
  AuctionTop5BiddingList: any = [];
  BidPlacePanel: boolean = false;
  alive = true;

  //************* Auction Bidding Place List Column And DataSource ****************/
  displayedColumns: string[] = ['SrNo', 'AuctionNo', 'AuctionTitle', 'StartDate', 'EndDate', 'Action'];
  dataSource = new MatTableDataSource(this.AuctionBiddingPlaceListBind);

  //************ For Use Multiple Pagination On Page ****************************/
  @ViewChildren(MatPaginator) paginator = new QueryList<MatPaginator>();
  @ViewChildren(MatSort) sort = new QueryList<MatSort>();

  constructor(private MsgServ: ToastrService, private servc: LiveBiddingViewService) {
  }

  ngOnInit() {
    this.FillLiveAuctionList();
  }

  FillLiveAuctionList() {

    let ResponseDecrpt = sessionStorage.getItem('loginSession');
    let loginlist = JSON.parse(window.atob(ResponseDecrpt));
    let Ind = 1;
    let OrgCode = loginlist[0]['OrgCode'];
    let CityCode = loginlist[0]['CityCode'];
    this.servc.FillLiveAuctionList(Ind, OrgCode, CityCode).subscribe(res => {
      if (res) {
        if (res.SuccessCD == 1) {
          this.AuctionBiddingPlaceListBind = res.RespData.Table;
          //  console.table( res.RespData);
          this.dataSource = new MatTableDataSource<any>(this.AuctionBiddingPlaceListBind);
          this.dataSource.paginator = this.paginator.toArray()[0];
          this.dataSource.sort = this.sort.toArray()[0];
        }
      }
      else {
        this.MsgServ.warning('Record Not Found....!!');
      }
    });
  }

  AuctionCount: number = 0;
  AuctionId: number;
  OnView(AuctionId) {
    this.AuctionId = 0;

    this.AuctionId = AuctionId;
    this.AuctionCount++;
    if (this.AuctionCount == 1) {
      this.BidPlacePanel = true;
      this.OnStartTimerEvery10SecondAutomaticReload();
      this.ShowStartBiddingListData = this.AuctionBiddingPlaceListBind.filter(x => x.AuctionId == AuctionId);
      // console.log(this.ShowStartBiddingListData);
    } else {
      alert('Please Close Running Auction, Then Start Another Auction...!!');
      return;
    }
  }

  private OnStartTimerEvery10SecondAutomaticReload() {
    Observable.timer(0, 10000)
      .takeWhile(() => this.alive) // only fires when component is alive
      .subscribe(() => {
        let ResponseDecrpt = sessionStorage.getItem('loginSession');
        let loginlist = JSON.parse(window.atob(ResponseDecrpt));
        let Ind = 2;
        let OrgCode = loginlist[0]['OrgCode'];
        let CityCode = loginlist[0]['CityCode'];
        let AuctionID = this.AuctionId;
        this.servc.FillBiddingTop5List(Ind, OrgCode, CityCode, AuctionID).subscribe(res => {
          if (res) {
            if (res.SuccessCD == 1) {
              this.AuctionTop5BiddingList = res.RespData.Table;
            }
          }
        });
      });
  }
  Close() {
    location.reload();

  }
  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

}
